/**
 * uniqueId returns a unique id
 * example: uniqueId();
 * @returns {number} returns a random number
 */
export const uniqueId = () => Math.floor(new Date().valueOf() * Math.random());
